import React from "react";

export const Page6Tamil = () => {
  return (
    <div className="page-tamil-container">
      <h1>அதிசய ஆலமரம் : </h1>
      <p>
        ஆலமரம் உள்ளது. இந்த மரத்துக்கு வயது யாருக்கும் தெரியவில்லை. இதுவரை
        விழுது விட்டதில்லை இப்பகுதியில் பல தடவை வீசிய புயல்காற்று இந்த மரத்தை
        மட்டும் அசைக்கவில்லை. பலத்த புயலில் பல பெரிய மரங்கள் விழுந்து விட்டது.
        ஆனால் விழுதே இல்லாத இந்த ஆலமரம் விழவே இல்லை. இதன் இலைகள் ஒரு பக்கம்
        பழுக்கும் போது மறுபக்கம் பச்சையாகவே இருக்குமாம். இது அதிசய ஆலமரம் தானே,
        கொளப்பாடு ஸ்ரீ அய்யனார் கோயில் ஸ்ரீ ஆதியண்ணன் கோயில் ஆகிய இரு ஆலயங்களின்
        திருப்பணியும், கும்பாபிஷேகமும் சிறப்பாக செய்வித்த பெங்களூர்
        <strong>திரு. S. துரைராஜ்</strong> அவர்களோடு உறு துணையாக இருந்து
        முழுப்பணியையும் சிறப்பாக செய்த
        <strong>திரு. G.ரமேஷ்</strong> அவர்கள் தன்னுடைய பணியை சொல்கிறார்
      </p>
      <p>
        வணக்கம், கொளப்பாட்டில் அமைந்துள்ள அகிலாண்டேஸ்வரி சமேத ஸ்ரீ சுந்தரேஸ்வரர்
        ஆலயம் கிராமவாசிகளின் பொருளுதவியாலும், ஒத்துழைப்பாலும் சிறப்பாக
        திருப்பணியும், கும்பாபிஷேகமு நடைப்பெற்றது. பின்னர் கிராமவாசிகள் பலரும்
        என்னிடம் ஐயனார் கோயில், ஆதியண்ணன் கோயில் இரண்டையும் திருப்பணி செய்ய
        முயற்சி எடுக்குமாறு தெரிவித்தார்கள். சிவன் கோயில் திருப்பணிக்கு உதவி
        செய்த மக்களிடம் குறுகிய காலத்தில் மறுபடியும் நன்கொடை பெற்று மக்களின்
        விருப்பத்தை பூர்த்தி செய்வது சிரமமாக இருக்கக் கூடும் என்பதால் "காலம்
        கனிந்து வரும்போது" அதையும் செய்து முடிக்கலாம் என்று சொல்லி வந்தேன்.
      </p>
      <p>
        ஒரு நல்ல நாளில் அய்யனார் கோயிலில் இருந்து எனக்கு ஓர் அழைப்பு வந்தது.
        சென்று பார்த்த போது பெங்களூரிலிருந்து கோயிலுக்கு பூஜை செய்வதற்காக வந்த
        திரு. துரைராஜ் என்னை அழைத்திருந்தார்.
      </p>
      <p style={{margin:0}}>
        எடுத்த எடுப்பிலேயே இரண்டு கோயில் களுக்கும் திருப்பணி செய்து
        கும்பாபிஷேகம் செய்ய உங்கள் ஒத்துழைப்பை கேட்கவே அழைத்தேன் என்றார்கள்.
        எனக்கோ ஆச்சரியமாக இருந்தது. எதிர்பார்த்திருந்த “காலம் கனிந்து விட்டது”
        போலும் என்று எண்ணினேன். இரண்டு கோயில்களையும் சீரமைத்து கும்பாபிஷேகம்
        செய்ய நிறைந்த செலவாகும் முதலில் உங்கள் உதவியைச் சொல்லுங்கள் என்றேன்.
        முழுச்செலவும் எங்கள் குடும்பத்தினரும், உறவினர்களும், நண்பர்களும்
        செய்வதாக சொல்லி இருக்கிறார்கள், கிராம மக்களின் உதவியையும் பெற்று கொண்டு
        சீரோடும், சிறப்போடும் பணி நடைபெற உதவி செய்யுங்கள் என்றார். பத்து நாட்கள்
        கழித்து வாருங்கள், கொத்தனார் ஸ்தபதியார், பெயிண்டர் இவர்களையும் அழைத்து
        வருகிறேன் அன்றைய தினம் பேசிக் கொள்வோம் என்றேன். சொன்னபடி குறித்த நாளில்
        கிராமவாசிகள் கூட்டம் கூட்டப்பட்டு திருப்பணி செய்ய முடிவெடுக்கப் பட்டது.
        மொத்த செலவும் சுமாராக ஐந்து லட்சம் ஆகலாம் என்று திட்டமிடப்பட்டது.
        வேலைலயை ஆரம்பிக்கச் சொல்லி அன்றைய தினமே ஒரு பெருந்தொகையை என்னிடம்
        கொடுத்தார்கள். நான் மிகவும் அச்சமடைந்தேன்.
      </p>
    </div>
  );
};
